import { behaviors } from '@tunein/web-common';

export const FETCH_USER = 'FETCH_USER';

function fetchUserEffect({ contentId }) {
  return {
    type: FETCH_USER,
    api: {
      endpoint: ['user', 'getUserFavorites'],
      args: [{ userIdentifier: contentId }],
      isWACBeta: true,
      // TODO: this transform won't be needed when migrating to Zustand
      // TODO: this is workaround transform to add showSeeMore property to containers until favorites rewrite
      transform: (response) => {
        const containers = response.containers.map((container) => {
          const { containerNavigation, presentation } = container;
          const layout = presentation?.layout;
          const isGalleryLayout = layout === 'Gallery' || layout === 'Carousel';

          return {
            ...container,
            ...presentation,
            children: container.children.map((child) => ({
              ...child,
              ...child.presentation,
            })),
            showSeeMore:
              Boolean(
                containerNavigation?.url ||
                  (containerNavigation?.destinationInfo &&
                    containerNavigation?.type !== behaviors.browse),
              ) && !isGalleryLayout,
          };
        });

        return { content: { ...response, containers } };
      },
    },
    meta: {
      contentId,
    },
  };
}

export function selectUser({ contentId }) {
  return fetchUserEffect({ contentId });
}
